import DatapharmTable from '@components/DatapharmTable/DatapharmTable';
import { mapToProductsData, getProductsTableColumnData } from './helpers';
import { createColumns } from '../../../helpers';
import { IAssignmentChangesDto, IDocumentDto, IProductChangesDto, IProductDto, IProductForm } from '@common/features/submission/types';
import * as Styled from './styles';
import { SubmissionTaskType } from '@common/types';
import { LookupWarning } from '../../LookupWarning/LookupWarning';
import { SubmissionTaskStatuses } from '@common/services/types';

interface Props {
  showLookupValidation?: boolean;
  isLoading: boolean;
  removeButtonText?: string;
  products: IProductDto[];
  unapprovedProductForms?: IProductForm[];
  documents: IDocumentDto[];
  productsChanges?: IProductChangesDto[];
  upcomingProductChanges?: IProductChangesDto[];
  isReadonly?: boolean;
  showDocumentCountChanges: boolean;
  submissionTaskType: SubmissionTaskType;
  taskStatus?: SubmissionTaskStatuses;
  assignments: IAssignmentChangesDto[];
  onEditXml?: () => void;
  onUpdateClick?: (productId: string) => void;
  onRemoveClick?: (productId: string) => void;
  onDetailsClick?: (productId: string) => void;
  onFormManageClick?: (formId: string) => void;
}

export const ProductsTab = ({
  showLookupValidation = false,
  isLoading,
  removeButtonText = 'Remove',
  products,
  documents,
  unapprovedProductForms,
  productsChanges,
  upcomingProductChanges,
  isReadonly = false,
  showDocumentCountChanges,
  submissionTaskType,
  taskStatus,
  assignments,
  onEditXml = () => {},
  onDetailsClick = () => {},
  onUpdateClick,
  onRemoveClick,
  onFormManageClick,
}: Props) => {
  const columnsData = getProductsTableColumnData(
    isReadonly,
    removeButtonText,
    showDocumentCountChanges,
    onEditXml,
    onDetailsClick,
    onUpdateClick,
    onRemoveClick,
  );
  const columns = createColumns(columnsData);
  const productsTableData = mapToProductsData(products, documents, submissionTaskType, productsChanges, upcomingProductChanges, assignments, taskStatus);

  return (
    <Styled.DetailsTableWrapper>
      {!isLoading && <DatapharmTable columns={columns} documents={productsTableData!} data-testid="products-table" />}
      {showLookupValidation && unapprovedProductForms && unapprovedProductForms.length > 0 && (
        <LookupWarning
          title="Product Forms pending approval:"
          newLookups={unapprovedProductForms}
          onManageClick={onFormManageClick}
        />
      )}
    </Styled.DetailsTableWrapper>
  );
};
